<template>
    <div :class="active ? 'block' : 'hidden'">
        <div class="fixed z-50 pin overflow-hidden bg-modal" @click.prevent="close"></div>
        <button @click.prevent="close" class="z-50 text-grey-light hover:text-grey-lightest outline-0 text-xl absolute pin-t pin-r p-2 m-2">
            <span class="icon"><i class="mdi mdi-close"></i></span>
        </button>
        <div class="fixed z-50 pin-t pin-x overflow-hidden max-w-sm mx-auto mt-24 px-4 md:px-0 mb-4">
            <div class="bg-white rounded shadow" @click.prevent="">
                <div class="flex items-top p-3 md:p-6 bg-white rounded-t">
                    <avatar :avatar="group.doctorAvatar" :name="group.doctorFirstName + ' ' + group.doctorLastName" class="mr-2 w-10 h-10 md:w-12 md:h-12"></avatar>
                    <div class="ml-4">
                        <div class="flex items-center">
                            <span class="icon mr-2 text-lg text-red-light"><i class="mdi mdi-map-marker"></i></span>
                            <span class="text-sm md:text-base">{{ group.officeZipCode }} {{ group.officeLocality }}</span>
                        </div>
                        <div class="flex items-center md:mt-1">
                            <span class="icon mr-2 text-lg text-blue-light"><i class="mdi mdi-account"></i></span>
                            <span class="text-sm md:text-base">{{ group.doctorFirstName + ' ' + group.doctorLastName }}</span>
                        </div>
                    </div>
                </div>
                <div class="uppercase tracking-wide text-grey-darker text-sm font-semibold px-3 md:px-6 mb-4">{{ $t('Select_an_availability') }}</div>
                <div class="max-h-timeslots overflow-scroll">
                    <router-link
                        :to="{ name: 'timeslot.show', params: { id: timeslot.id } }"
                        v-for="timeslot in sortedTimeslots"
                        :key="timeslot.id"
                        class="block w-full border-t px-6 py-3 hover:bg-grey-lightest text-grey-darker">
                        {{ timeslot.date | momentFormat('YYYY-MM-DD', $t('date_selector_format')) }} {{ $t('at') }} {{ timeslot.time | momentFormatTime($t('time_format')) }}
                    </router-link>
                    <div class="py-1 rounded-b border-t"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import helpers from '@/mixins/helpers'

export default {
    name: 'timeslot-selection-modal',

    props: ['active', 'group'],

    mixins: [helpers],

    data () {
        return {
            selectedTimeslot: null
        }
    },

    computed: {
        sortedTimeslots () {
            return _.sortBy(this.group.timeslots, ['date', 'time'])
        }
    },

    methods: {
        close () {
            this.$emit('close')
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/Patient/TimeslotSelectionModal.vue